import React from "react";
import { Typography } from "@material-tailwind/react";
import { Link } from "react-router-dom";
import { ROUTES } from "../../constants";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="w-full bg-white border-t border-gray-100 pt-12 pb-8">
      <div className="max-w-7xl mx-auto px-6">
        
        {/* Top Section: Brand & Links */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-8 mb-12">
          <div className="text-center md:text-left">
            <Typography className="text-2xl font-black tracking-tighter text-blue-900">
              CampusIRA<span className="text-blue-600">.</span>
            </Typography>
            <Typography className="text-sm text-gray-500 font-medium mt-1">
              Empowering students through shared wisdom.
            </Typography>
          </div>

          <ul className="flex flex-wrap justify-center gap-x-8 gap-y-4">
            <li>
              <Link
                to={ROUTES.posts}
                className="text-sm font-semibold text-gray-600 hover:text-blue-600 transition-colors"
              >
                Experiences
              </Link>
            </li>
            <li>
              <Link
                to={ROUTES.jobs}
                className="text-sm font-semibold text-gray-600 hover:text-blue-600 transition-colors"
              >
                Job Openings
              </Link>
            </li>
            <li>
              <Link
                to={ROUTES.faq}
                className="text-sm font-semibold text-gray-600 hover:text-blue-600 transition-colors"
              >
                FAQ
              </Link>
            </li>
            <li>
              <Link
                to={ROUTES.help}
                className="text-sm font-semibold text-gray-600 hover:text-blue-600 transition-colors"
              >
                Report a Bug
              </Link>
            </li>
          </ul>
        </div>

        {/* Bottom Section: Copyright */}
        <div className="pt-8 border-t border-gray-50 flex flex-col md:flex-row justify-between items-center gap-4">
          <Typography className="text-xs font-medium text-gray-400">
            &copy; {currentYear} CampusIRA | Built for the Student Community
          </Typography>
          
          <div className="flex items-center gap-6">
            {/* Replaced href="#" with actual links or removed them if not ready */}
            <Link
              to={ROUTES.help}
              className="text-xs font-bold text-gray-400 hover:text-gray-900 transition-colors"
            >
              Support
            </Link>
            <Link
              to={ROUTES.contact}
              className="text-xs font-bold text-gray-400 hover:text-gray-900 transition-colors"
            >
              Contact Us
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;